export function common() {
  // const header = document.getElementById("js-header");

  // const headerScroll = () => {
  //   window.addEventListener("scroll", () => {
  //     if (window.scrollY > 1 && window.innerWidth > 768) {
  //       header.classList.add("is-scroll");
  //     } else {
  //       header.classList.remove("is-scroll");
  //     }
  //   });
  // };

  // headerScroll();

  window.addEventListener("load", () => {
    if (window.document.body.id === "top") {
      const scrollContainer = document.querySelector(".l-frame__center"); // 中央カラム（スクロール対象）
      const rightUI = document.querySelector(".p-rightUi"); // 右UI（表示したい要素）
      console.log(rightUI);
      const handleScroll = () => {
        if (window.scrollY > -100) {
          rightUI.classList.add("is-visible");
          scrollContainer.removeEventListener("scroll", handleScroll); // 一回だけ実行
        }
      };
      window.addEventListener("scroll", handleScroll);
    }
  });
}
